import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Send, ArrowRight, Eye } from 'lucide-react';
import { Button } from './ui/button';

const AuthGateModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  if (!open) return null;

  const goToAuth = (mode) => {
    localStorage.setItem('authRedirect', '/plan-event');
    navigate(`/auth?mode=${mode}`);
  };

  return (
    <div className="fixed inset-0 z-[9998]" data-testid="auth-gate-modal">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      {/* Bottom sheet */}
      <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl animate-in slide-in-from-bottom duration-300 pb-safe">
        {/* Drag handle */}
        <div className="flex justify-center pt-3 pb-1">
          <div className="w-10 h-1 rounded-full bg-gray-300" />
        </div>

        <div className="px-6 pt-4 pb-8 max-w-md mx-auto">
          {/* Icon */}
          <div className="mx-auto mb-4 w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center">
            <img src="/celeyapp-icon-green.png" alt="Celey" className="h-6 w-6" />
          </div>

          {/* Copy */}
          <h2 className="text-xl font-bold text-gray-900 text-center mb-1" data-testid="auth-gate-title">
            You're almost there
          </h2>
          <p className="text-gray-500 text-sm text-center mb-6">
            Create an account to send your request
          </p>

          {/* Actions */}
          <div className="space-y-3">
            <Button
              className="w-full py-5 rounded-xl bg-emerald-700 hover:bg-emerald-800 text-base font-semibold"
              onClick={() => goToAuth('signup')}
              data-testid="auth-gate-create-btn"
            >
              Continue with Email <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              variant="outline"
              className="w-full py-5 rounded-xl border-2 text-base font-semibold"
              onClick={() => goToAuth('login')}
              data-testid="auth-gate-signin-btn"
            >
              Log In
            </Button>
            <button
              onClick={onClose}
              className="w-full flex items-center justify-center gap-2 py-3 text-sm text-gray-500 hover:text-gray-700 font-medium transition-colors"
              data-testid="auth-gate-close-btn"
            >
              Keep Planning
            </button>
          </div>

          {/* Footer */}
          <p className="text-center text-xs text-gray-400 mt-4">
            Your event plan will be saved
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthGateModal;
